import { render, staticRenderFns } from "./ToggleFullscreenButton.vue?vue&type=template&id=52c54c0c&scoped=true&"
import script from "./ToggleFullscreenButton.vue?vue&type=script&lang=js&"
export * from "./ToggleFullscreenButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c54c0c",
  null
  
)

export default component.exports